// FilterItem.styles.tsx
import { Stack, styled } from '@mui/material';

const StyledBox = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.secondary.main,
  border: `1px solid ${theme.palette.divider[5]}`,
  borderRadius: theme.spacing(0.5),
  backdropFilter: `blur(${theme.spacing(1)})`,
  '& .MuiMenuItem-root': {
    [theme.breakpoints.down('lg')]: {
      borderRadius: theme.spacing(0.5),
    },
  },
  [theme.breakpoints.up('lg')]: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  [theme.breakpoints.down('lg')]: {
    gap: theme.spacing(1.5),
    backgroundColor: 'transparent',
    border: 0,
  },
  '& .FBAction': {
      marginTop: theme.spacing(2.5),
  },
  
}));

export default StyledBox;
